<svg
  class="tracks"
  [class.detection-mode]="detectionMode"
  (click)="mouseClick($event)"
  (mousemove)="mouseMove($event)"
  #svg
  viewBox="0 0 1280 720"
  xmlns:svg="http://www.w3.org/1999/html"
>
  <style>
    .loading {
      font-size: 16px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      fill: white;
      text-shadow: -2px -2px 2px #0000008a;
    }
    .track {
      transition: transform 20ms ease-in;
      cursor: pointer;
    }
    .player-number {
      font-size: 16px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      fill: rgb(255, 255, 255);
    }
    .player-number-selected {
      stroke: red;
      stroke-width: 2px;
    }
    .possession-player {
      stroke: green;
      stroke-width: 2px;
    }
    .player-name {
      font-size: 10px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      fill: rgb(255 255 255);
    }
    .matched {
      stroke: rgb(0, 255, 0);
    }
    .unmatched {
      fill: rgba(255, 0, 0, 0.25);
      stroke: rgb(255, 0, 0);
    }
    .split {
      fill: rgba(255, 136, 15, 0.25);
      stroke: rgb(255, 136, 15);
    }
    .new-detection {
      fill: none;
      stroke: rgb(255, 203, 15);
    }
    .bounding-box {
      opacity: 0.25;
      stroke-width: 1;
    }
    .selected {
      opacity: 0.75;
      stroke-width: 5;
      stroke-dasharray: 5 5 5 5;
    }
    .medium-confidence {
      opacity: 0.5;
    }
    .low-confidence {
      opacity: 0.25;
    }
    .details {
      fill: rgb(72 72 72);
      font-size: 12px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      transform: translatex(-70px);
    }
    .showcase-brackets {
      fill: none;
      stroke-width: 2.5;
      stroke-linecap: round;
      stroke-linejoin: round;
    }
    .showcase-track-id {
      font-size: 9px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      fill: rgba(220, 220, 220, 0.9);
      text-anchor: middle;
    }
    .showcase-team-text {
      font-size: 11px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      font-weight: 600;
      fill: rgb(255, 255, 255);
      text-anchor: middle;
      opacity: 0.95;
    }
    .showcase-pill-bg {
      opacity: 1;
    }
    .showcase-team-bg {
      opacity: 0.6;
    }
    .showcase-pill-number-bg {
      fill: rgba(255, 255, 255, 0.95);
    }
    .showcase-pill-number {
      font-size: 11px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      font-weight: 700;
      text-anchor: middle;
      dominant-baseline: central;
    }
    .showcase-pill-name {
      font-size: 11px;
      font-family: 'Roboto', 'Helvetica', sans-serif;
      font-weight: 700;
      fill: rgb(255, 255, 255);
      text-anchor: middle;
      dominant-baseline: central;
      letter-spacing: 0.3px;
    }
  </style>

  <text class="loading" x="10" y="25" *ngIf="!onlyNumbers && !isShowcase">
    Frame: {{ frameNumber }}
  </text>
  <text class="loading" x="150" y="25" *ngIf="detectionMode && !isShowcase">
    Detection Mode
  </text>

  <text *ngIf="loading && !isShowcase" class="loading" x="560" y="400">
    Loading Player Tracks...
  </text>

  <rect
    *ngIf="
      !isShowcase &&
      detectionStart &&
      detectionEnd &&
      detectionWidth > 0 &&
      detectionHeight > 0
    "
    class="new-detection"
    x="0"
    y="0"
    fill=""
    [ngStyle]="{
      transform:
        'translate(' +
        detectionStart[0] * cx +
        'px,' +
        detectionStart[1] * cy +
        'px)'
    }"
    [attr.width]="detectionWidth * cx"
    [attr.height]="detectionHeight * cy"
  ></rect>

  <ng-container *ngIf="isShowcase">
    <ng-container *ngFor="let t of detections; trackBy: trackByFn">
      <ng-container *ngIf="isShowcaseStageActive('tracking')">
        <path
          class="showcase-brackets"
          [attr.stroke]="showcaseBracketColor"
          [attr.d]="cornerBracketsPath(t)"
        ></path>
        <text
          class="showcase-track-id"
          [attr.x]="bboxCenterX(t)"
          [attr.y]="bboxBottomY(t) + 12"
        >
          track: {{ shortTrackId(t) }}
        </text>
      </ng-container>

      <ng-container *ngIf="isShowcaseStageActive('teams') && teamShortName(t)">
        <rect
          class="showcase-team-bg"
          [attr.x]="bboxCenterX(t) - 32"
          [attr.y]="bboxTopY(t) - 18"
          width="64"
          height="14"
          rx="3"
          [attr.fill]="showcaseTeamColor(t)"
        />
        <text
          class="showcase-team-text"
          [attr.x]="bboxCenterX(t)"
          [attr.y]="bboxTopY(t) - 7"
        >
          Team: {{ teamShortName(t) }}
        </text>
      </ng-container>

      <ng-container *ngIf="isShowcaseStageActive('players') && getPlayerNumber(t)">
        <rect
          class="showcase-pill-bg"
          [attr.x]="bboxCenterX(t) - 55"
          [attr.y]="bboxTopY(t) - 38"
          width="110"
          height="16"
          rx="2"
          [attr.fill]="showcaseTeamColor(t)"
        />
        <rect
          class="showcase-pill-number-bg"
          [attr.x]="bboxCenterX(t) - 53"
          [attr.y]="bboxTopY(t) - 36"
          width="20"
          height="12"
          rx="2"
        />
        <text
          class="showcase-pill-number"
          [attr.x]="bboxCenterX(t) - 43"
          [attr.y]="bboxTopY(t) - 30"
          [attr.fill]="showcaseTeamColor(t)"
        >
          {{ getPlayerNumber(t) }}
        </text>
        <text
          class="showcase-pill-name"
          [attr.x]="bboxCenterX(t) + 13"
          [attr.y]="bboxTopY(t) - 30"
        >
          {{ playerLastNameUpper(t) }}
        </text>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngFor="let t of detections; trackBy: trackByFn">
    <ng-container *ngIf="!isShowcase && getPlayerNumber(t)">
      <rect
        class="track"
        width="28"
        height="23"
        [attr.fill]="teamColor(t)"
        (click)="clickDetection(t)"
        rx="10"
        [ngClass]="{
          'high-confidence':
            t.trackAssignment?.numberDetectionScore >= highConfidenceThreshold,
          'medium-confidence':
            t.trackAssignment?.numberDetectionScore >=
              mediumConfidenceThreshold &&
            t.trackAssignment?.numberDetectionScore < highConfidenceThreshold,
          'low-confidence':
            t.trackAssignment?.numberDetectionScore < mediumConfidenceThreshold,
          'player-number-selected':
            t.trackAssignment?.player === selectedPlayer,
          'possession-player':
            t.trackAssignment?.player === puckPossessionPlayer
        }"
        [ngStyle]="{
          transform:
            'translate(' +
            (((t.bbox[0] + t.bbox[2]) * cx) / 2 - 14 | decimalValue) +
            'px,' +
            (t.bbox[1] * cy - 27) +
            'px)'
        }"
      />
      <text
        class="track player-number"
        (click)="clickDetection(t)"
        [ngClass]="{
          'high-confidence':
            t.trackAssignment?.numberDetectionScore >= highConfidenceThreshold,
          'medium-confidence':
            t.trackAssignment?.numberDetectionScore >=
              mediumConfidenceThreshold &&
            t.trackAssignment?.numberDetectionScore < highConfidenceThreshold,
          'low-confidence':
            t.trackAssignment?.numberDetectionScore < mediumConfidenceThreshold
        }"
        [ngStyle]="{
          transform:
            'translate(' +
            (((t.bbox[0] + t.bbox[2]) * cx) / 2 - 9 | decimalValue) +
            'px,' +
            (t.bbox[1] * cy - 10) +
            'px)'
        }"
      >
        {{ getPlayerNumber(t) }}
      </text>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!onlyNumbers && !isShowcase">
    <text
      *ngFor="let t of detections; trackBy: trackByFn"
      class="track player-name"
      [ngStyle]="{
        transform:
          'translate(' +
          (((t.bbox[0] + t.bbox[2]) * cx) / 2 + 17 | decimalValue) +
          'px,' +
          (t.bbox[1] * cy - 30) +
          'px) rotate(-45deg)'
      }"
    >
      {{ getPlayerName(t) }}
      <ng-container *ngIf="t.trackAssignment?.team">
        {{ t.trackAssignment?.team }}
      </ng-container>
      <ng-container *ngIf="t.trackAssignment?.numberDetectionScore">
        {{ t.trackAssignment?.numberDetectionScore * 100 | number : '1.0-0' }}%
      </ng-container>
    </text>
  </ng-container>
  <!-- TODO: filter negative width/height -->
  <ng-container *ngIf="!onlyNumbers && !isShowcase">
    <rect
      *ngFor="let t of detections; trackBy: trackByFn"
      class="track bounding-box"
      [ngClass]="{
        unmatched: !t.trackAssignment,
        matched: t.trackAssignment && !this.selectedFrom,
        split: t.trackId === selectedTrackId && this.selectedFrom,
        selected: t.trackId === selectedTrackId
      }"
      x="0"
      y="0"
      [attr.fill]="teamColor(t)"
      [attr.stroke]="teamColor(t)"
      [ngStyle]="{
        transform:
          'translate(' + t.bbox[0] * cx + 'px,' + t.bbox[1] * cy + 'px)'
      }"
      [attr.width]="(t.bbox[2] - t.bbox[0]) * cx"
      [attr.height]="(t.bbox[3] - t.bbox[1]) * cy"
      cursor="pointer"
      style=""
    ></rect>
    <text
      *ngFor="let t of detections; trackBy: trackByFn"
      class="track details"
      [attr.x]="t.bbox[0] * cx + 65"
      [attr.y]="t.bbox[3] * cx + 20"
    >
      {{ t.trackId.substr(0, 6) }}
    </text>
  </ng-container>
</svg>
<div
  *ngIf="!isShowcase"
  class="thumbnails"
  style="
    position: absolute;
    background-color: rgba(0, 0, 0, 0.75);
    bottom: 50px;
    width: 100%;
    z-index: 100;
  "
>
  <app-player-track-thumbnails [thumbnails]="thumbnails">
  </app-player-track-thumbnails>
</div>
